<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger</h4>
      </div>
    </div>

    <table class="large fixed clickable" style="width: 100%">
      <thead>
        <tr>
          <th>Innstilling</th>
          <th class="align-right">Redigerbar</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in sortedLinks" :key="item.likname" @click="onClick(item)">
          <td>{{item.name}}</td>
          <td class="align-right">{{item.type === 'editable' ? 'Ja' : 'Nei'}}</td>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'InstillingerList',
  data () {
    return {
      links: [
        { name: 'Auksjonskoder', linkname: 'AuksjonList', type: 'editable' },
        { name: 'Debug: Bilagsoverføring', linkname: 'BilagsoverforingList', type: 'editable' },
        { name: 'Debug: Oppgjør', linkname: 'OppgjordebugList', type: 'editable' },
        { name: 'Auksjonstype', linkname: 'AuksjonTypeList', type: 'editable' },
        { name: 'Objekttype', linkname: 'ObjektTypeList', type: 'editable' },
        { name: 'Kontraktstype', linkname: 'KontraktTypeList', type: 'editable' },
        { name: 'Varetype', linkname: 'VareTypeList', type: 'editable' },
        { name: 'Kvitteringstype', linkname: 'KvitteringTypeList', type: 'editable' },
        { name: 'Labeltype', linkname: 'LabelTypeList', type: 'editable' },
        { name: 'Bilagtype', linkname: 'BilagTypeList', type: 'editable' },
        { name: 'Bilagart', linkname: 'BilagartTypeList', type: 'editable' },
        { name: 'Avdeling', linkname: 'AvdelingList', type: 'readonly' },
        { name: 'Expertavdeling', linkname: 'ExpertavdelingList', type: 'editable' },
        { name: 'Land', linkname: 'LandList', type: 'editable' },
        { name: 'Postreg', linkname: 'PostregList', type: 'readonly' },
        { name: 'Legitimasjon', linkname: 'LegitimasjonList', type: 'editable' },
        { name: 'Lokasjon', linkname: 'LokasjonList', type: 'editable' },
        { name: 'Mva', linkname: 'MvaList', type: 'editable' },
        { name: 'Betalingsart', linkname: 'BetalingsartList', type: 'editable' },
        { name: 'Objektsignert', linkname: 'ObjektsignertList', type: 'editable' },
        { name: 'Objektbeskrivelse', linkname: 'ObjektbeskrivelseList', type: 'editable' },
        // { name: 'Label', linkname: 'LabelList', type: 'editable' },
        { name: 'Label', linkname: 'Label', type: 'editable' },
        { name: 'Dokumenttype', linkname: 'DokumenttypeList', type: 'editable' },
        { name: 'Kategori', linkname: 'KategoriList', type: 'editable' },
        { name: 'Kundekategoritype', linkname: 'KundekategoritypeList', type: 'editable' },
        { name: 'Vare', linkname: 'VareList', type: 'editable' },
        { name: 'Vareenhet', linkname: 'VareenhetList', type: 'editable' },
        { name: 'Bokforgruppe', linkname: 'BokforgruppeList', type: 'editable' },
        { name: 'Fraktgruppe', linkname: 'FraktgruppeList', type: 'editable' },
        { name: 'Freighttype', linkname: 'FreighttypeList', type: 'editable' },
        { name: 'Kunstner', linkname: 'KunstnerList', type: 'editable' },
        { name: 'Merknad', linkname: 'MerknadList', type: 'editable' },
        { name: 'Printer', linkname: 'PrinterList', type: 'editable' },
        { name: 'Ute lagringsdager', linkname: 'UtelagringsdagerList', type: 'editable' },
        { name: 'Trekking av kort', linkname: 'AutochargeintervalList', type: 'editable' }
      ]
    }
  },
  computed: {
    sortedLinks: function () {
      return this._.sortBy(this.links, ['name'])
    }
  },
  methods: {
    onClick: function (item) {
      this.$router.push({name: item.linkname})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerList.vue